import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { message } from "antd";
import axiosHttp from "services/axiosHttp";

//create action
export const updateValueChain = createAsyncThunk(
  "updateValueChain",
  async ({ id, data, form, history }) => {
    const token = localStorage.getItem("auth_token");
        const config = {
            headers: {
                "Authorization": `Bearer ${token}`,
                "Access-Control-Allow-Origin": '*',
                "Content-Type": "application/json",
                "Accept": "application/json",
            }
        };
    const response = await axiosHttp.patch(
      `vc/update?id=${id}`,
      data,
      config
    );

    form.resetFields();
    message.success("Value Chain successfully updated!");
    history("/app/organization/value-chain");
    return response.data;
  }
);

const valueChainUpdateSlice = createSlice({
  name: "valueChainUpdate",
  initialState: {
    isLoading: false,
    error: null,
  },

  extraReducers: (builder) => {
    builder.addCase(updateValueChain.pending, (state, action) => {
      state.isLoading = true;
    });

    builder.addCase(updateValueChain.fulfilled, (state, action) => {
      state.isLoading = false;
      state.data = action.payload;
    });
    builder.addCase(updateValueChain.rejected, (state, action) => {
      state.isLoading = false;
      state.error = action.payload;
    });
  },
});

export default valueChainUpdateSlice.reducer;